<template>
	<div>
		<div class="detial-box" v-if="data.onlinePaymentGatewayText === 'زرین پال'">
			<div class="d-flex flex-wrap">
				<div class="ml-5"><span class="title">نتیجه وریفای: </span><span class="value">{{ data.zarinPalPurchase.verifyStatus }}</span></div>
				<div class="ml-5"><span class="title">وضعیت: </span><span class="value">{{ data.zarinPalPurchase.status }}</span></div>
				<div class="ml-5"><span class="title">شماره پیگیری: </span><span class="value">{{ data.zarinPalPurchase.refId }}</span></div>
			</div>
		</div>
		<div class="detial-box" v-if="data.onlinePaymentGatewayText === 'بانک سامان'">
			<div class="d-flex flex-wrap">
				<div class="ml-5"><span class="title">شماره ترمینال: </span> <span class="value">{{ data.sepPurchase.terminalId }}</span></div>
				<div class="ml-5"><span class="title">نتیجه:</span> <span class="value">{{ data.sepPurchase.state }}</span></div>
				<div class="ml-5"><span class="title">وضعیت:</span> <span class="value">{{ data.sepPurchase.status }}</span></div>
				<div class="ml-5"><span class="title">نتیجه وریفای:</span> <span class="value">{{ data.sepPurchase.verifyResultDescription }}</span></div>
				<div class="ml-5"><span class="title">رسید دیجیتال:</span> <span class="value">{{ data.sepPurchase.refNum }}</span></div>
				<div class="ml-5"><span class="title">شماره پیگیری:</span> <span class="value">{{ data.sepPurchase.traceNo }}</span></div>
			</div>
		</div>
		<div class="detial-box" v-if="data.onlinePaymentGatewayText === 'بانک پارسیان'">
			<div class="d-flex flex-wrap">
				<div class="ml-5"><span class="title">شماره ترمینال: </span> <span class="value">{{ data.ipgParsianPurchase.terminalNo }}</span></div>
				<div class="ml-5"><span class="title">وضعیت:</span> <span class="value">{{ data.ipgParsianPurchase.status }}</span></div>
				<div class="ml-5"><span class="title">خطای توکن:</span> <span class="value">{{ data.ipgParsianPurchase.tokenErrorDesc }}</span></div>
				<div class="ml-5"><span class="title">نتیجه وریفای:</span> <span class="value">{{ data.ipgParsianPurchase.verifyStatus }}</span></div>
				<div class="ml-5"><span class="title">رسید دیجیتال:</span> <span class="value">{{ data.ipgParsianPurchase.rrn }}</span></div>
				<div class="ml-5"><span class="title">شماره سفارش:</span> <span class="value">{{ data.ipgParsianPurchase.orderId }}</span></div>
			</div>
		</div>
		<div class="detial-box" v-if="data.onlinePaymentGatewayText === 'بانک ملی (سداد)'">
			<div class="d-flex flex-wrap">
				<div class="ml-5"><span class="title">شماره ترمینال: </span> <span class="value">{{ data.sadadPurchase.terminalId }}</span></div>
				<div class="ml-5"><span class="title">نتیجه:</span> <span class="value">{{ data.sadadPurchase.resCode }}</span></div>
				<div class="ml-5"><span class="title">وضعیت:</span> <span class="value">{{ data.sadadPurchase.description }}</span></div>
				<div class="ml-5"><span class="title">شماره مرجع تراکنش:</span> <span class="value">{{ data.sadadPurchase.retrivalRefNo }}</span></div>
				<div class="ml-5"><span class="title">شماره پیگیری:</span> <span class="value">{{ data.sadadPurchase.systemTraceNo }}</span></div>
			</div>
		</div>
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'

	export default {
		name: 'GatewayDetails',
		props: {
			data: {
				type: Object,
			},
		},
		data: () => ({}),
		computed: {

		},
	}
</script>
<style scoped>
	.detial-box .title {
		font-size: 11px;
		color: #808080;
	}

	.detial-box .value {
		font-size: 11px;
		color: black;
	}
</style>